// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@sc/XDL/types";

export default {
    primary: {
        main: "#0088C7",
        contrast: "#FFFFFF",
    },
    secondary: {
        main: "#898D8D",
        contrast: "#FFFFFF",
    },
    common: {
        background: "#FFFFFF",
        backgroundContrast: "#000000",
        accent: "#FFFFFF", //
        accentContrast: "#000000",
        border: "#C7CACA",
        disabled: "#EEEEEE",
        ui1: "#FFFFFF",
        ui2: "#EEEEEE",
        ui3: "#C7CACA",
        ui4: "#898D8D",
        ui5: "#666666",
        ui6: "#454848",
        ui7: "#000000",
        ui8: "#005177",
        ui9: "#1B272F",
        ui10: "#FFD0B0",
        ui11: "#ff6700",
        ui12: "#C7EEFF",
        white: "#FFFFFF",
        black: "#000000",
    },
    text: {
        main: "#000000",
        disabled: "#000000",
        accent: "#000000",
        link: "#0088C7",
    },
    success: {
        main: "#00A65A",
        light: "#D9F2E7",
        contrast: "#FFFFFF",
    },
    danger: {
        main: "#E4104E",
        light: "#FBDBE5",
        contrast: "#FFFFFF",
    },
    warning: {
        main: "#DAA91C",
        light: "#FDF9DE",
        contrast: "#FFFFFF",
    },
    info: {
        main: "#53ACDB",
        light: "#DDEEF8",
        contrast: "#FFFFFF",
    },
} as xBaseTheme["colors"];
